<template>
  <div>
      {{ i18n.$t('WebsiteName')}}
      <button @click="setLang('en_US')">en</button>
      <button @click="setLang('zh_CN')">zh</button>
  </div>
</template>
 
<script>
  import { useI18n } from "@/i18nPlugin";
  import { store } from "@/store";
  export default {
    name: 'Menu',
    setup() {
      const i18n = useI18n();
      const setLang = (value) => {
        store.commit('setLang', value);
        localStorage.setItem('setLang', value);
        i18n.locale.value = value
      }
      return { i18n, setLang };
    }
  }
</script>